const KEY = 'screenplay_session_v1';

const BASE = (import.meta.env.BASE_URL || '/').replace(/\/$/, '');

export function loadSession() {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!parsed?.session_id) return null;
    return parsed;
  } catch {
    return null;
  }
}

export function saveSession({ session_id, username, is_admin = false, permissions_enabled = true }) {
  localStorage.setItem(
    KEY,
    JSON.stringify({
      session_id,
      username,
      is_admin: !!is_admin,
      permissions_enabled: !!permissions_enabled,
    }),
  );
}

// Whether this viewer may create/rename/delete projects: the admin — or
// anyone, when the server runs in legacy open mode (ADMIN_USERNAME unset).
// Defaults to false for a session object that predates these flags; App.jsx
// refreshes stored sessions on every boot revalidate.
export function canManageProjects(session) {
  return !!session && (!!session.is_admin || session.permissions_enabled === false);
}

export function clearSession() {
  localStorage.removeItem(KEY);
}

export async function validateSession(sessionId) {
  const res = await fetch(`${BASE}/auth/validate`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ session_id: sessionId }),
  });
  if (!res.ok) return { valid: false };
  return res.json();
}

export async function requestApproval(username) {
  const res = await fetch(`${BASE}/auth/request`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ username }),
  });
  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error(err.error || `request failed (${res.status})`);
  }
  return res.json();
}

export async function pollStatus(requestId) {
  const res = await fetch(`${BASE}/auth/status?request_id=${encodeURIComponent(requestId)}`);
  if (!res.ok) throw new Error(`status failed (${res.status})`);
  return res.json();
}
